import React from 'react';
import clsx from 'clsx';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { IconCheckmark, NotificationImportant, Clipboard } from '@insurancemenu/imenu-components-lib/dist/icons';
import { SavingStatus } from 'types/electionService';
import { createStyles } from './styles';

interface SavingStatusProps {
  resave: () => void;
  status: SavingStatus;
}

type SavingStatusType = {
  [K in SavingStatus]: JSX.Element;
};

export enum SAVING_STATUS {
  SAVING = 'Saving',
  SUCCESSFUL_SAVING = 'All Changes Saved',
  FAILED_SAVING = 'Not able to save',
}

const ElectionSavingStatus = ({ resave, status }: SavingStatusProps): JSX.Element => {
  const classes = createStyles();

  const SAVING_STATUS_TITLES: SavingStatusType = Object.freeze({
    SUCCESSFUL_SAVING: (
      <div className={clsx(classes.savingStatusWrapper, classes.savedChanges)}>
        <IconCheckmark width="2.3rem" />
        <p className={classes.savingStatus}>{SAVING_STATUS.SUCCESSFUL_SAVING}</p>
      </div>
    ),
    SAVING: (
      <div className={clsx(classes.savingStatusWrapper, classes.savingInProcess)}>
        <Clipboard width="2.3rem" />
        <p className={classes.savingStatus}>{SAVING_STATUS.SAVING}</p>
      </div>
    ),
    FAILED_SAVING: (
      <div className={clsx(classes.savingStatusWrapper, classes.failedSaving)}>
        <NotificationImportant width="2.3rem" />
        <p className={classes.savingStatus}>{SAVING_STATUS.FAILED_SAVING}</p>
        <Button
          className={classes.resaveBtn}
          type="text"
          color="custom"
          customColor={colors.orange[600]}
          onClick={resave}
        >
          Pls try again
        </Button>
      </div>
    ),
  });
  return SAVING_STATUS_TITLES[status];
};

export default ElectionSavingStatus;
